import React from 'react';
import { Container, Header, Button, Segment, Icon, Message } from 'semantic-ui-react';

const Registration = () => (
  <div>
    <Container text style={{ padding: '4em 0' }}>
      <Segment boxy padded='very' textAlign='center' raised>
        <Header as='h1'>Nincs még SCHAccod?</Header>

        <Message error icon>
          <Icon name='info circle' />
          <Message.Content>
            Még nem találtunk hozzád tartozó SCHAccot. Kérjük, regisztrálj az alábbi linken a
            folytatáshoz!
          </Message.Content>
        </Message>

        <Button
          primary
          size='large'
          as='a'
          href='https://admin.sch.bme.hu/register'
          target='_blank'
          rel='noopener noreferrer'
          style={{ marginTop: '1em' }}
        >
          Regisztráció az admin felületen
          <Icon name='external alternate' style={{ marginLeft: '10px' }} />
        </Button>
      </Segment>
    </Container>
  </div>
);

export default Registration;
